import React, { useState } from 'react';
import './Shop.css';

const Shop = () => {
  const [cart, setCart] = useState([]);
//   const [cartOpen, setCartOpen] = useState(false);

  const products = [
    {
      id: 1,
      name: 'Car Wax Premium',
      price: 24.99,
      category: 'Detailing',
      image: '🧴',
      description: 'Professional grade car wax for protection and shine',
    },
    {
      id: 2,
      name: 'Paint Ceramic Coating',
      price: 89.99,
      category: 'Protection',
      image: '💎',
      description: 'Long-lasting ceramic protection for your paint',
    },
    {
      id: 3,
      name: 'Alloy Wheel Cleaner',
      price: 14.99,
      category: 'Cleaning',
      image: '🧪',
      description: 'Powerful cleaner for dirty alloy wheels',
    },
    {
      id: 4,
      name: 'Scratch Remover',
      price: 19.99,
      category: 'Repair',
      image: '✨',
      description: 'Gentle scratch removal for light scratches',
    },
    {
      id: 5,
      name: 'Clay Bar Kit',
      price: 12.99,
      category: 'Detailing',
      image: '📦',
      description: 'Deep clean clay bar for paint preparation',
    },
    {
      id: 6,
      name: 'Car Polishing Compound',
      price: 34.99,
      category: 'Polishing',
      image: '🎯',
      description: 'Multi-purpose polishing compound for all paint types',
    },
    {
      id: 7,
      name: 'Microfiber Cloth Pack',
      price: 9.99,
      category: 'Tools',
      image: '🧽',
      description: 'Premium microfiber cloths (pack of 5)',
    },
    {
      id: 8,
      name: 'Paint Sealant',
      price: 44.99,
      category: 'Protection',
      image: '🛡️',
      description: 'Professional paint sealant for lasting protection',
    },
    {
      id: 9,
      name: 'Dent Removal Kit',
      price: 29.99,
      category: 'Tools',
      image: '🔨',
      description: 'DIY dent removal tools set',
    },
  ];

  const addToCart = (product) => {
    const existing = cart.find((item) => item.id === product.id);
    if (existing) {
      setCart(
        cart.map((item) =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        )
      );
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
    }
  };

  const removeFromCart = (productId) => {
    setCart(cart.filter((item) => item.id !== productId));
  };

  const getTotalPrice = () => {
    return cart.reduce((total, item) => total + item.price * item.quantity, 0).toFixed(2);
  };

  const getTotalItems = () => {
    return cart.reduce((total, item) => total + item.quantity, 0);
  };

  return (
    <main className="shop-page">
      {/* Header */}
      <section className="shop-header">
        <div className="container">
          <h1>Shop</h1>
          <p>Professional car care products and tools</p>
        </div>
      </section>

      <div className="container p-40">
        <div className="shop-layout">
          {/* Products Grid */}
          <div className="products-section">
            <div className="products-grid">
              {products.map((product) => (
                <div key={product.id} className="product-card">
                  <div className="product-image">{product.image}</div>
                  <h3>{product.name}</h3>
                  <p className="product-category">{product.category}</p>
                  <p className="product-description">{product.description}</p>
                  <div className="product-footer">
                    <span className="product-price">£{product.price.toFixed(2)}</span>
                    <button
                      className="btn btn-primary"
                      onClick={() => addToCart(product)}
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Cart Sidebar */}
          <div className="cart-section">
            <div className="cart-container">
              <h2>Shopping Cart</h2>
              {cart.length === 0 ? (
                <p className="empty-cart">Your cart is empty</p>
              ) : (
                <>
                  <div className="cart-items">
                    {cart.map((item) => (
                      <div key={item.id} className="cart-item">
                        <div className="cart-item-info">
                          <p className="cart-item-name">{item.name}</p>
                          <p className="cart-item-price">
                            £{item.price.toFixed(2)} x {item.quantity}
                          </p>
                        </div>
                        <button
                          className="remove-btn"
                          onClick={() => removeFromCart(item.id)}
                          title="Remove item"
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>

                  <div className="cart-summary">
                    <div className="summary-row">
                      <span>Subtotal:</span>
                      <span>£{getTotalPrice()}</span>
                    </div>
                    <div className="summary-row">
                      <span>Items:</span>
                      <span>{getTotalItems()}</span>
                    </div>
                  </div>

                  <div className="cart-total">
                    <strong>Total: £{getTotalPrice()}</strong>
                  </div>

                  <button className="btn btn-primary btn-block">
                    Proceed to Checkout
                  </button>
                </>
              )}

              <div className="cart-info">
                <h4>ℹ️ About Our Products</h4>
                <p>
                  All products are professional-grade and recommended by our technicians. Fast
                  delivery available.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Products Section */}
      <section className="featured-products p-40">
        <div className="container">
          <h2 className="text-center">Featured Products</h2>
          <p className="section-intro text-center">
            Check out our best-selling professional car care products
          </p>
          <div className="grid grid-3">
            <div className="featured-card">
              <img src="/assets/shop1.PNG" alt="Turbocharger" className="featured-image" />
              <h3>Turbocharger</h3>
              <p className="featured-price">£350.00</p>
              <button className="btn btn-primary btn-small" onClick={() => addToCart(products[0])}>
                Add to Cart
              </button>
            </div>
            <div className="featured-card">
              <img src="/assets/shop2.PNG" alt="Ceramic Coating" className="featured-image" />
              <h3>Radiator Fan</h3>
              <p className="featured-price">£89.99</p>
              <button className="btn btn-primary btn-small" onClick={() => addToCart(products[1])}>
                Add to Cart
              </button>
            </div>
            <div className="featured-card">
              <img src="/assets/shop3.PNG" alt="Alternator" className="featured-image" />
              <h3>Alternator</h3>
              <p className="featured-price">£115.00</p>
              <button className="btn btn-primary btn-small" onClick={() => addToCart(products[2])}>
                Add to Cart
              </button>
            </div>
            <div className="featured-card">
              <img src="/assets/shop4.PNG" alt="Scratch Remover" className="featured-image" />
              <h3>Power Steering Pump</h3>
              <p className="featured-price">£75.00</p>
              <button className="btn btn-primary btn-small" onClick={() => addToCart(products[3])}>
                Add to Cart
              </button>
            </div>
            <div className="featured-card">
              <img src="/assets/shop5.PNG" alt="AC Compressor" className="featured-image" />
              <h3>AC Compressor</h3>
              <p className="featured-price">£175.00</p>
              <button className="btn btn-primary btn-small" onClick={() => addToCart(products[4])}>
                Add to Cart
              </button>
            </div>
            <div className="featured-card">
              <img src="/assets/shop6.PNG" alt="Intercooler" className="featured-image" />
              <h3>Intercooler</h3>
              <p className="featured-price">£175.00</p>
              <button className="btn btn-primary btn-small" onClick={() => addToCart(products[5])}>
                Add to Cart
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="shop-info">
        <div className="container">
          <h2 className="text-center">Why Purchase from Our Shop?</h2>
          <div className="grid grid-3">
            <div className="info-card">
              <span className="info-icon">✓</span>
              <h3>Quality Guaranteed</h3>
              <p>All products tested and certified by our expert technicians</p>
            </div>
            <div className="info-card">
              <span className="info-icon">🚚</span>
              <h3>Fast Delivery</h3>
              <p>Orders processed quickly with next-day delivery available</p>
            </div>
            <div className="info-card">
              <span className="info-icon">💬</span>
              <h3>Support Available</h3>
              <p>Expert advice available - contact us for product recommendations</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Shop;
